import React from 'react';
import {Card, Grid, Icon, Input, Table} from 'semantic-ui-react';
import AccessoriesModal from './modals/accessories/accessoriesModal';

const ComboDetailsTab = ({comboDetailsState, handleComboAccessories, editComboAccessory, disabled}) => {
  const isSelected = (acc) => {
    const accSelected = comboDetailsState.comboDetails.find((x) => x.code === acc.code);
    return accSelected ? true : false;
  };

  return (
    <Grid>
      <Grid.Row columns={3} textAlign='left'>
        <Grid.Column>
          <AccessoriesModal disabled={disabled} isSelected={isSelected}
            handleComboAccessories={handleComboAccessories} />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Card fluid raised>
            <Table textAlign='center'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Código</Table.HeaderCell>
                  <Table.HeaderCell>Franquicia</Table.HeaderCell>
                  <Table.HeaderCell>Descripción</Table.HeaderCell>
                  <Table.HeaderCell>Cantidad</Table.HeaderCell>
                  <Table.HeaderCell>Precio</Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {comboDetailsState.comboDetails.map((acc, i) => {
                  return (
                    <Table.Row key={i}>
                      <Table.Cell content={acc.code} />
                      <Table.Cell content={acc.franchise} />
                      <Table.Cell content={acc.name} />
                      <Table.Cell content={
                        <Input type='Number' value={acc.quantity} size='mini' disabled={disabled}
                          className={`input-center${!acc.quantity || Number(acc.quantity) === 0 ? ' required' : ''}`}
                          onChange={(e, input) =>
                            editComboAccessory(acc, 'quantity', Number.parseInt(input.value, 10))} />
                      } />
                      <Table.Cell content={
                        <Input type='Number' value={acc.price} size='mini' disabled={disabled}
                          className={`input-center${Number(acc.price) === 0 ? ' required' : ''}`}
                          onChange={(e, input) => editComboAccessory(acc, 'price', input.value)} />
                      } />
                      <Table.Cell content={
                        <Icon name='trash' link size='large' color='red' disabled={disabled}
                          onClick={(e) => handleComboAccessories(e, acc)} />} />
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </Card>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default ComboDetailsTab;
